export const getPriceDetails = (product, price, isProductPage) => {
  if (!product || !product.type) {
    return { text: "" };
  }

  let displayPrice = 0;
  let text = "$0 for subscribers";

  if (isProductPage) {
    switch (product.type) {
      case 1: // Audiotour
        text = "or free with subscription";
        break;
      case 2: // Ticket
      case 3: // Audiotour + Ticket
        displayPrice = price * 0.85;
        text = `or ${product.currency}${displayPrice.toFixed(2)} with subscription`;
        break;
      default:
        break;
    }
  } else {
    switch (product.type) {
      case 2: // Ticket
      case 3: // Audiotour + Ticket
        displayPrice = price * 0.85;
        text = `${product.currency}${displayPrice.toFixed(2)} for subscribers`;
        break;
      default:
        break;
    }
  }

  return { text };
};
